/**
 * Узел Note (Label) — фигура с path FIGURE_NOTE, как в diagram-js (ArchimateRenderer).
 * Цвета и выравнивание текста совпадают с diagram-js: белая заливка, полупрозрачная обводка, по умолчанию left-top.
 */
import ArchimateNodeType from '../ArchimateNodeType';
import {NOTE} from '../../util/ModelUtil';
import {DEFAULT_NOTE_COLOR, BLACK_SHADOW} from '../../util/ColorUtil';
import {textAlignToLabelAttrs} from '../textAlignUtil';

const DEFAULT_SIZE = {width: 120, height: 55};

export default class NoteNodeType extends ArchimateNodeType {
	static get typeName() {
		return NOTE;
	}

	get shapeId() {
		return 'archimate:label';
	}

	get defaultSize() {
		return DEFAULT_SIZE;
	}

	canConnectTo() {
		return true;
	}

	get canBeParent() {
		return false;
	}

	buildNodeConfig(pathMap, options = {}) {
		const {id, x = 0, y = 0, width, height, label, fillColor, lineColor, textAlign} = options;
		const align = textAlignToLabelAttrs(textAlign, {
			defaultHorizontal: 'left',
			defaultVertical: 'top',
		});
		const w = width ?? DEFAULT_SIZE.width;
		const h = height ?? DEFAULT_SIZE.height;
		const notePath = pathMap.getScaledPath('FIGURE_NOTE', {
			xScaleFactor: 1,
			yScaleFactor: 1,
			containerWidth: w,
			containerHeight: h,
			position: {mx: 0, my: 0},
		});
		const nodeAttrs = {
			body: {
				d: notePath,
				fill: fillColor ?? DEFAULT_NOTE_COLOR,
				stroke: lineColor ?? BLACK_SHADOW,
				strokeWidth: 1,
			},
			label: {
				text: label ?? '',
				fontSize: 12,
				fill: '#000000',
				...align,
				textWrap: {width: -15, height: '100%', ellipsis: true, breakWord: true},
			},
		};
		return {
			id,
			x,
			y,
			width: w,
			height: h,
			shape: this.shapeId,
			attrs: nodeAttrs,
		};
	}
}
